export default __webpack_public_path__ + "static/media/featured-item-3.21fc5c1e.png";